import { gql, graphql } from "react-apollo"

const MUTATE_CREATE_ASSET = gql`
  mutation CreateAsset($fileKey: String!, $mimeType: String!) {
    createAsset(fileKey: $fileKey, mimeType: $mimeType) {
      id
      mediaURL
      mimeType
    }
  }
`

const mutateCreateAsset = graphql(MUTATE_CREATE_ASSET, {
  name: "mutateCreateAsset",
  props: ({ mutateCreateAsset }) => ({
    createAsset: (fileKey: string, mimeType: string) =>
      mutateCreateAsset({
        variables: { fileKey, mimeType }
      })
  })
})

export default mutateCreateAsset



// WEBPACK FOOTER //
// ./src/Slides/queries/mutateCreateAsset.js